


























































import {
  computed, defineComponent, reactive, Ref, ref, watch,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import { useFormat } from 'vivat';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import getDeliveryNoteHistory from '@/gql/dashboard/getDeliveryNoteHistory.gql';

import DeliveryNoteObject from '@/components/Overall/DeliveryNoteObject.vue';
import ViewDeliveryMarkerModal from '@/components/Delivery/ViewDeliveryMarkerModal.vue';
import AbsenceObject from '@/components/Overall/AbsenceObject.vue';

dayjs.extend(relativeTime);

const NOW = useFormat.date().computerShortDate();

const DeliveryNoteHistory = defineComponent({
  components: {
    DeliveryNoteObject,
    ViewDeliveryMarkerModal,
    AbsenceObject,
  },
  setup() {
    const dayJSNOW = useFormat.date(NOW);
    function displayDate(date: string) {
      return useFormat.date(date).displayShortThaiDate();
    }
    const deliveryNotesHistory = reactive([
      { display: '-7', date: dayJSNOW.dayjs.subtract(7, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '-6', date: dayJSNOW.dayjs.subtract(6, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '-5', date: dayJSNOW.dayjs.subtract(5, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '-4', date: dayJSNOW.dayjs.subtract(4, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '-3', date: dayJSNOW.dayjs.subtract(3, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '-2', date: dayJSNOW.dayjs.subtract(2, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '-1', date: dayJSNOW.dayjs.subtract(1, 'day').format('YYYY-MM-DD'), data: {} },
      { display: 'ปัจจุบัน', date: dayJSNOW.dayjs.format('YYYY-MM-DD'), data: {} },
      { display: '+1', date: dayJSNOW.dayjs.add(1, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '+2', date: dayJSNOW.dayjs.add(2, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '+3', date: dayJSNOW.dayjs.add(3, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '+4', date: dayJSNOW.dayjs.add(4, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '+5', date: dayJSNOW.dayjs.add(5, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '+6', date: dayJSNOW.dayjs.add(6, 'day').format('YYYY-MM-DD'), data: {} },
      { display: '+7', date: dayJSNOW.dayjs.add(7, 'day').format('YYYY-MM-DD'), data: {} },
    ]);

    const filter = reactive({
      range: {
        from: NOW,
        to: NOW,
      },
    });

    const computedDateInput = computed(() => ({
      range: {
        from: useFormat.date(filter.range.from).dayjs.subtract(7, 'day').format('YYYY-MM-DD'),
        to: useFormat.date(filter.range.from).dayjs.add(7, 'day').format('YYYY-MM-DD'),
      },
    }));

    const { result: getDeliveryNoteHistoryResult, loading: getDeliveryNoteHistoryLoading } = useQuery(getDeliveryNoteHistory, computed(() => ({
      filterDeliveryDateBetween: filter.range.from ? computedDateInput.value.range : undefined,
    })), () => ({
      fetchPolicy: 'network-only',
    }));

    const vehicles = useResult(getDeliveryNoteHistoryResult, [], (data) => data.vehicles.data);

    // watch(() => getDeliveryNoteHistoryResult.value, (newVal, oldVal) => {
    //   if (!getDeliveryNoteHistoryLoading.value && newVal !== oldVal) {

    //   }
    // });

    function compareDate(date: string, date2: string | undefined = undefined): number {
      return dayjs(date).diff(dayjs(date2), 'day');
    }
    function findMatchDeliveryNotes(vehicle: any, date: string) {
      const result: any[] = [];
      vehicle.deliveryNotes.forEach((dn: any) => {
        if (dn.deliveryDate === date) result.push(dn);
      });
      return result;
    }
    function findMatchAbsenceLog(vehicle: any, date: string) {
      for (let i = 0; i < vehicle.absenceLogs.length; i += 1) {
        if (
          (compareDate(vehicle.absenceLogs[i].effectiveDate, date) === 0 || compareDate(date, vehicle.absenceLogs[i].leaveUntil) === 0)
          || (compareDate(vehicle.absenceLogs[i].effectiveDate, date) < 0 && compareDate(date, vehicle.absenceLogs[i].leaveUntil) < 0)
        ) {
          return vehicle.absenceLogs[i];
        }
      }
      return null;
    }

    const viewMapModal = ref(null);
    const mapMarkers: Ref<{ delivery: any; lat: number; lng: number; open: boolean }[]> = ref([]);
    const vehicleTraverse: Ref<{ car: any; stamps: { lat: number; lng: number }[] }> = ref({
      car: {
        id: -1,
        license: '',
        lastPosition: { lat: 0, lng: 0 },
      },
      stamps: [],
    });
    const computedCars = computed(() => (vehicleTraverse.value.car.id > -1 ? [vehicleTraverse.value.car] : []));
    function pendingToViewMap(deliveryNote: any) {
      mapMarkers.value = deliveryNote.deliveries.map((dv: any) => ({
        delivery: dv,
        open: false,
        lat: parseFloat(dv.lat) >= -90 && parseFloat(dv.lat) <= 90 ? parseFloat(dv.lat) : 0,
        lng: parseFloat(dv.long) >= -180 && parseFloat(dv.long) <= 180 ? parseFloat(dv.long) : 0,
      }));
      if (deliveryNote.locations.length > 0) {
        const [lastPos] = deliveryNote.locations;
        vehicleTraverse.value.car = { id: deliveryNote.vehicle.id, license: deliveryNote.vehicle.license, lastPosition: { lat: lastPos.lat, lng: lastPos.long } };
        vehicleTraverse.value.stamps = deliveryNote.locations.map((location: any) => ({
          lat: parseFloat(location.lat) >= -90 && parseFloat(location.lat) <= 90 ? parseFloat(location.lat) : 0,
          lng: parseFloat(location.long) >= -180 && parseFloat(location.long) <= 180 ? parseFloat(location.long) : 0,
        }));
        vehicleTraverse.value.stamps.splice(0, 1);
      } else {
        vehicleTraverse.value.car = { id: -1 };
        vehicleTraverse.value.stamps = [];
      }
      (viewMapModal.value as any).open();
    }

    return {
      NOW,
      displayDate,

      findMatchDeliveryNotes,
      deliveryNotesHistory,
      vehicles,

      findMatchAbsenceLog,

      viewMapModal,
      pendingToViewMap,
      mapMarkers,
      vehicleTraverse,
      computedCars,
    };
  },
});

export default DeliveryNoteHistory;
